import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
// import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

// init Swiper:
const swiper = new Swiper('.properties-slider', {
    // configure Swiper to use modules
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    // fade
    // effect: "fade",
    // autoplay: {
    //     delay: 4000,
    // },
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 20
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    }
});
